module.exports = __webpack_public_path__ + "img/Foreground_Left.74c49752.svg";